import AuthContainer from '@auth/components/AuthContainer'
import LoginForm from '@auth/components/LoginForm'
import { toastSuccess } from '@utils'
import parse from 'html-react-parser'
import { tr } from 'mmfintech-commons'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const Login = () => {
  const location: any = useLocation()

  useEffect(() => {
    if (location?.state?.origin && location?.state?.origin === 'password-reset') {
      toastSuccess(
        tr('FRONTEND.SUCCESSFUL_RESET_PASSWORD.TOAST_SUCCESS_TITLE', 'Your password has been changed successfully'),
        tr('FRONTEND.SUCCESSFUL_RESET_PASSWORD.TOAST_SUCCESS_SUBTITLE', 'You can use your new password to sign in.'),
        {
          className: 'forgot-password-modal-success',
          duration: 3_000,
          style: { backgroundColor: '#E5F5F0' }
        }
      )
    }
  }, [location?.state])

  return (
    <AuthContainer
      title={parse(tr('FRONTEND.WELCOME.AUTH.TITLE', 'Welcome to<br/>The Kingdom Bank'))}
      subtitle={tr('FRONTEND.WELCOME.AUTH.SUBTITLE', 'Our excellent customer support team is available 24/7.')}
    >
      <LoginForm />
    </AuthContainer>
  )
}

export default Login
